
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bulk-resize/editor",
      function () {
        return require("private-next-pages/bulk-resize/editor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bulk-resize/editor"])
      });
    }
  